import React, {Component} from 'react';
import Select2 from 'react-select2-wrapper';
import {connect} from 'react-redux';
import {threadWorkflowStatusUpdate} from '../../redux/actions';
import {getSelect2Locale} from '../../util';

class ThreadWorkflowStatusEdit extends Component {

    constructor(props) {
        super(props);
        
        this.onSelect = this.onSelect.bind(this);
    }

    onSelect(e) {
        this.props.updateWorkflowStatus(parseInt(e.params.data.id));
    }

    render() {
        const data = this.props.statuses.map((status) => ({text: status.name, id: status.id}));
        const workflowStatus = this.props.thread.workflowStatus;

        const {isLoading} = this.props;

        return (
            <Select2 data={data}
                     value={workflowStatus}
                     disabled={isLoading}
                     onSelect={this.onSelect}
                     options={{
                         theme: 'bootstrap4',
                         width: '100%',
                         language: getSelect2Locale(),
                     }}
            />
        );
    }
}

export default connect(
    (state, props) => {
        const threadType = state.getIn(['threadTypes', props.thread.threadType]);

        return {
            statuses: state.getIn(['workflow', threadType.workflow]).statuses.map((id) => (
                state.getIn(['workflowStatuses', id])
            )),
            isLoading: state.getIn(['threadWorkflowStatusMeta', 'loading']),
            hasError: state.getIn(['threadWorkflowStatusMeta', 'error']) !== null,
        };
    },
    (dispatch) => ({
        updateWorkflowStatus(workflowStatusId) {
            return dispatch(threadWorkflowStatusUpdate(workflowStatusId));
        },
    }),
)(ThreadWorkflowStatusEdit);
